module.exports = __webpack_public_path__ + "img/P150T_weapon_120.edf867f4.png";